var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications-container'),_c('loader'),(!_vm.isLoadingDictionary)?_c('router-view'):_vm._e(),_c('profile-update-required-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }